import { CorporateApi } from './corporate.api';

const corporateApi = new CorporateApi();

export { corporateApi };
